import CustomerInfoForm from "../../components/checkout/CustomerInfoForm";
import OrderSummary from "../../components/checkout/OrderSummary";
import PaymentMethodSelector from "../../components/checkout/PaymentMethodSelector";
import TransactionStatusModal from "../../components/modal/TransactionStatusModal";
import ErrorModal from "../../components/modal/ErrorModal ";
import PaymentProcessingModal from "../../components/modal/PaymentProcessingModal";
import LanguageSelector from "../../components/LanguageSelector";
import PaymentSuccessModal from "../../components/modal/PaymentSuccessModal";

import {
  PageContainer,
  PageHeader,
  CheckoutContainer,
  LeftSection,
  RightSection,
  Logo,
} from "../../components/checkout/shared/CheckoutStyledComponents";

const ClassicSkin = ({
  checkoutPageConfDto,
  checkoutPageFields,
  routingEntries,
  platformItemDetails,
  itemDetails,
  formData,
  isFormValid,
  billingPlatformId,
  planId,
  addons,
  selectedAddons,
  sessionId,
  couponCodes,
  isLoading,
  isRoutingLoaded,
  hasNoPaymentMethods,
  showModal,
  transactionStatus,
  transactionId,
  isErrorModalVisible,
  isPaymentProcessingModalVisible,
  paymentProcessingHeader,
  paymentProcessingMessage,
  isTransactionDetailsModalVisible,
  handleFormChange,
  handleValidationChange,
  handleSubmit,
  setShowModal,
  setTransactionStatus,
  setErrorModalVisible,
  setIsPaymentProcessingModalVisible,
  setIsTransactionDetailsModalVisible,
  setCheckoutPageConfDto,
}) => {
  return (
    <PageContainer>
      <PageHeader>
        <LanguageSelector />
      </PageHeader>

      <PaymentProcessingModal
        show={isPaymentProcessingModalVisible}
        setShow={setIsPaymentProcessingModalVisible}
        heading={paymentProcessingHeader}
        content={paymentProcessingMessage}
        transactionId={transactionId}
        setTransactionStatus={setTransactionStatus}
        setTransactionStatusModal={setShowModal}
      />

      <TransactionStatusModal
        show={showModal}
        onClose={() => setShowModal(false)}
        status={transactionStatus}
        transactionId={transactionId}
        hostedPageRedirect={null}
        fallbackRedirectUrl={checkoutPageConfDto?.checkoutRedirectUrl}
      />

      {isTransactionDetailsModalVisible && (
        <PaymentSuccessModal
          show={isTransactionDetailsModalVisible}
          transactionId={transactionId}
          onClose={() => setIsTransactionDetailsModalVisible(false)}
        />
      )}

      <CheckoutContainer>
        <LeftSection>
          <Logo>
            {checkoutPageConfDto?.logoUrl ? (
              <img src={checkoutPageConfDto.logoUrl} alt="Company Logo" />
            ) : (
              <span style={{ fontSize: 12, color: "#6b7280" }}>Logo</span>
            )}
          </Logo>

          <CustomerInfoForm
            formData={formData}
            onChange={handleFormChange}
            checkoutPageFields={checkoutPageFields}
            formValidations={handleValidationChange}
            itemDetails={itemDetails}
            disabled={hasNoPaymentMethods}
          />

          <PaymentMethodSelector
            selectedMethod={formData.paymentMethod}
            routingEntries={routingEntries}
            onChange={(method) => handleFormChange({ paymentMethod: method })}
            itemDetails={itemDetails}
            formData={formData}
            billingPlatformId={billingPlatformId}
            billingPlatformName={itemDetails?.billingPlatformName}
            planId={planId}
            platformItemDetails={platformItemDetails}
            selectedAddons={selectedAddons}
            checkoutPageConfDto={checkoutPageConfDto}
            setCheckoutPageConfDto={setCheckoutPageConfDto}
            isLoading={isLoading}
            isRoutingLoaded={isRoutingLoaded}
            sessionId={sessionId}
          />
        </LeftSection>

        {billingPlatformId && platformItemDetails && (
          <RightSection>
            {billingPlatformId ? (
              <OrderSummary
                isFormValid={isFormValid}
                onSubmit={handleSubmit}
                itemDetails={itemDetails}
                platformItemDetails={platformItemDetails}
                checkoutPageConfDto={checkoutPageConfDto}
                checkoutPageFields={checkoutPageFields}
                formData={formData}
                billingConnectionId={billingPlatformId}
                planId={planId}
                addons={addons}
                selectedAddons={selectedAddons}
                disabled={hasNoPaymentMethods}
                sessionId={sessionId}
                presetCouponCodes={couponCodes}
              />
            ) : (
              <div>OrderSummary conditions not met</div>
            )}
          </RightSection>
        )}
      </CheckoutContainer>

      <ErrorModal
        show={isErrorModalVisible}
        onClose={() => setErrorModalVisible(false)}
        message="This plan may no longer be available in its current form. Please contact the merchant for assistance."
        redirectUrl="/"
        buttonText="Go Back"
        variant="danger"
        icon="bi-exclamation-triangle-fill"
        size="lg"
        centered
        animation="fade"
        showCountdown={false}
      />
    </PageContainer>
  );
};

export default ClassicSkin;
